import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TodoRoutingModule } from './todo-routing.module';
import { TodoComponent } from './todo.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TodoRoutingModule, TranslateModule],
  declarations: [TodoComponent],
})
export class TodoModule {}
